module.exports = __webpack_public_path__ + "img/icon-primary.f801634b.svg";